import { defineMessages } from 'react-intl';

export default defineMessages({
  homeLink: {
    id: 'authenticator.onboarding.publicBar.homeLink',
    defaultMessage: 'Revers.io website',
  },
});
